export default __webpack_public_path__ + "static/media/project1.81f80d3c.png";